import { createGuid } from "cesium";
import { Site } from "./site";
export class RoadStructure {
    connectionNodes;
    road;
    constructor(road) {
        this.connectionNodes = [];
        this.road = road;
    }
    getConnectionInfo(point) {
        const site = Site.getInstance();
        const parentRoad = site.getRoad(point.info.structureInfo.id);
        if (parentRoad) {
            const info = parentRoad.getClosestPointInfoOnPath(point.localPosition);
            //Hack: There are no segments so the whole road is treated as a single segment
            const points = parentRoad.getPathPoints();
            const bounds = [points[0], points[points.length - 1]];
            const proportionInTotal = info.distanceFromStart_3D / parentRoad.getLength();
            const proportionInBounds = proportionInTotal;
            return { bounds, proportionInBounds, proportionInTotal };
        }
    }
    // when new road is created or updated, connection Nodes gets created
    // this road being child road
    // parent can be any structure
    getConnectionNodes() {
        const connectionNodes = [];
        const getConnectionNode = (point, index) => {
            const site = Site.getInstance();
            const parentStructure = site.structureManager.getStructure(point.info.structureInfo.id);
            if (!parentStructure) {
                return undefined;
            }
            const connectionInfo = parentStructure.getConnectionInfo(point);
            const connectionNode = {
                id: createGuid(),
                from: {
                    id: point.info.structureInfo.id,
                    proportionInTotal: connectionInfo.proportionInTotal,
                },
                to: {
                    id: this.road.id,
                    controlPointIndex: index,
                },
            };
            return connectionNode;
        };
        //for road just check 2 points
        // if (this.road.controlPoints[0]?.pointInfo?.info?.structureInfo) {
        // 	//where this point is picked from
        // 	// this.getPositionForSectionPlane
        // 	const connectionNode = getConnectionNode(
        // 		this.road.controlPoints[0].pointInfo,
        // 		0,
        // 	);
        // 	connectionNode && connectionNodes.push(connectionNode);
        // }
        // if (
        // 	this.road.controlPoints[this.road.controlPoints.length - 1]?.pointInfo
        // 		?.info?.structureInfo
        // ) {
        // 	const connectionNode = getConnectionNode(
        // 		this.road.controlPoints[this.road.controlPoints.length - 1].pointInfo,
        // 		this.road.controlPoints.length - 1,
        // 	);
        // 	connectionNode && connectionNodes.push(connectionNode);
        // }
        return connectionNodes;
    }
    // private updateNodeForProportionInTotal(
    // 	node: IConnectionNode,
    // ) {
    // 	//update total Proportion
    // 	//distance to that point
    // 	const distanceInthisSegment = node.from.proportionInBounds * segment.length;
    // 	node.from.proportionInTotal =
    // 		(distanceInthisSegment + distanceToSegment) / this.road.getLength();
    // }
    //when updated the parent, update the children
    updateConnectionOnAddUpdatePoint() {
        const site = Site.getInstance();
        const nodes = site.structureManager.getImmediateChildrenNodes(this.road.id);
        for (const node of nodes) {
            //check if segment exists;
            //   const parentRoad = commandInputs.roadData.get(node.from.id);
            // const parentSegments = this.road.getRoadSegments();
            // const segments = parentSegments.filter(
            // 	(s) =>
            // 		Cartesian3.equals(s.startPoint, node.from.bounds[0]) &&
            // 		Cartesian3.equals(s.endPoint, node.from.bounds[1]),
            // );
            // if (segments.length > 0) {
            // 	this.updateNodeForProportionInTotal(node, segments[0]);
            // } else {
            // 	this.updateNodeForProportionInBounds(node);
            // }
        }
    }
    //return deleted connectionNodes
    updateConnectionOnDeletePoint() {
        const site = Site.getInstance();
        const nodes = site.structureManager.getImmediateChildrenNodes(this.road.id);
        const nodesToDelete = [];
        for (const node of nodes) {
            //check if segment exists;
            //   const parentRoad = commandInputs.roadData.get(node.from.id);
            // const parentSegments = this.road.getRoadSegments();
            // const segments = parentSegments.filter(
            // 	(s) =>
            // 		Cartesian3.equals(s.startPoint, node.from.bounds[0]) &&
            // 		Cartesian3.equals(s.endPoint, node.from.bounds[1]),
            // );
            // if (segments.length > 0) {
            // 	this.updateNodeForProportionInTotal(node, segments[0]);
            // } else {
            // 	//check if first point or last point is deleted
            // 	const segmentsWithFirstPoint = parentSegments.filter((s) =>
            // 		Cartesian3.equals(s.startPoint, node.from.bounds[0]),
            // 	);
            // 	const segmentsWithLastPoint = parentSegments.filter((s) =>
            // 		Cartesian3.equals(s.endPoint, node.from.bounds[1]),
            // 	);
            // 	if (
            // 		segmentsWithFirstPoint.length > 0 &&
            // 		segmentsWithLastPoint.length > 0
            // 	) {
            // 		this.updateNodeForProportionInBounds(node);
            // 	} else {
            // 		nodesToDelete.push(node);
            // 	}
            // }
        }
        const newNodes = nodes.filter((n) => !nodesToDelete.includes(n));
        nodes.length = 0;
        nodes.push(...newNodes);
        //
        return nodesToDelete;
    }
    updateGeometry() {
        this.road.updateRoadGeometry();
    }
    getPointInfoAtProportionIntotal(proportion) {
        return this.road.getPointInfoAtDistance(this.road.getLength() * proportion);
    }
}
//# sourceMappingURL=road-structure.js.map